import { useNavigate } from "react-router-dom";
import { createColumnHelper } from "@tanstack/react-table";
// import { FaTrashAlt, FaEye } from "react-icons/fa";
import { formatDuration, getTimeAgo } from "../../utils/date-utils";
import UserDemoTableUi from "./UserDemoTableUi";
import { useAdminData } from "../../lib/useAdminData";
import useCommonStore from "../../store/CommonStore";
import { useEffect } from "react";

function prepareColumns(columnHelper: any, handleActions: any) {
  return [
    columnHelper.accessor((row: any) => row.chatListName, {
      id: "List Name",
      cell: (info: any) => {
        const original = info.row.original;

        return (
          <div className="  text-gray-800 text-base truncate w-full space-y-2 max-w-xs ">
            <div className="font-semibold text-gray-800 text-base">
              {original?.username || "--"}
            </div>
            <div className="  text-xs text-gray-600  ">
              {original?.user_email || "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Name</div>,
    }),

    columnHelper.accessor((row: any) => row.registered, {
      id: "registered",
      cell: (info: any) => {
        const original = info?.row?.original;

        return (
          <>
            <div className="font-medium text-gray-800 text-base">
              {getTimeAgo(original?.user_created_at) || "--"}
            </div>
          </>
        );
      },
      header: () => <div>Registered</div>,
    }),

    columnHelper.accessor((row: any) => row.location, {
      id: "location",
      cell: (info: any) => {
        const original = info?.row?.original;

        return (
          <div className="font-medium text-gray-800 text-base max-w-xs">
            {Array.isArray(original?.country) && original.country.length > 1 ? (
              original.country[1]
            ) : typeof original?.country === "string" ? (
              original.country
            ) : (
              <div className="flex justify-center items-center w-full">--</div>
            )}
          </div>
        );
      },
      header: () => <div>Location</div>,
    }),

    columnHelper.accessor((row: any) => row.lastActive, {
      id: "lastActive",
      cell: (info: any) => {
        const original = info?.row?.original;

        return (
          <div className="font-medium text-gray-800 text-base max-w-xs">
            {original?.login_time ? (
              getTimeAgo(original?.login_time)
            ) : (
              <span className=" flex justify-center items-center">--</span>
            )}
          </div>
        );
      },
      header: () => <div>Last Active</div>,
    }),

    columnHelper.accessor((row: any) => row.loginCount, {
      id: "loginCount",
      cell: (info: any) => {
        const original = info?.row?.original;

        return (
          <div className="font-medium text-center text-base max-w-xs">
            {original.user_login_count ? original.user_login_count : 0}
          </div>
        );
      },
      header: () => <div>Login Count </div>,
    }),

    columnHelper.accessor((row: any) => row.totalSessionTime, {
      id: "totalSessionTime",
      cell: (info: any) => {
        const original = info?.row?.original;
        const userActivity = original?.user_activity || [];

        const totalTimeSpent = userActivity.reduce(
          (acc: number, activity: any) =>
            acc + (activity.total_time_spent || 0),
          0
        );

        const formatDuration = (seconds: number) => {
          const hrs = Math.floor(seconds / 3600);
          const mins = Math.floor((seconds % 3600) / 60);
          const secs = seconds % 60;
          return `${hrs.toString().padStart(2, "0")}:${mins
            .toString()
            .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
        };

        return (
          <div className="font-medium  text-base text-center">
            {formatDuration(totalTimeSpent)}
          </div>
        );
      },
      header: () => <div className="text-center">Total Session Time</div>,
    }),

    columnHelper.accessor((row: any) => row.sessionDuration, {
      id: "sessionDuration",
      cell: (info: any) => {
        const original = info?.row?.original;

        return (
          <div className="flex flex-col gap-1">
            {original?.session_duration ? (
              <div className="font-semibold text-gray-800 text-base max-w-xs">
                {formatDuration(original.session_duration)}
              </div>
            ) : (
              <div className="flex justify-center items-center w-full">--</div>
            )}
          </div>
        );
      },
      header: () => (
        <div className="flex flex-col">
          <div>Avg.Session Duration</div>
        </div>
      ),
    }),
  ];
}

function UserDemoTable() {
  const { userLogs, loadingStates, refetchFunctions } = useAdminData();

  const userFetch = refetchFunctions.refetchUserLogs;

  const { userLogPage, userLogPageSize, setUserLogPage, setUserLogPageSize } =
    useCommonStore();

  // const apiData = Array.isArray(sessions?.Sessions) ? sessions?.Sessions : [];

  const apiData = Array.isArray(userLogs?.user_logs) ? userLogs?.user_logs : [];

  const columnHelper = createColumnHelper();

  const columns = prepareColumns(columnHelper, handleActions);

  const navigate = useNavigate();

  //   const [selectedId, setSelectedId] = useState<string | null>(null);

  //   function handleView(fetchId: string) {}

  //   function handleFetch(fetchType: string, fetchId: string) {
  //     // setType(fetchType);
  //     setSelectedId(fetchId);
  //   }

  useEffect(() => {
    userFetch();
  }, [userLogPage, userLogPageSize, userFetch]);

  function handleActions(fetchType: string, fetchId: string) {
    if (!loadingStates?.isUserLogsLoading && fetchType === "view") {
      navigate(`/chat/${fetchId}`);
    }
    if (!loadingStates?.isUserLogsLoading && fetchType === "delete") {
      // console.log("delete");
    }
  }

  // if (loadingStates?.isUserLogsLoading) {
  //   return <Loader />;
  // }

  return (
    <UserDemoTableUi
      data={apiData}
      columns={columns}
      // pagination={userLogs}
      noDataMessage="No user logs found"
      tableTitle=""
      onLoadMore={() => {
        setUserLogPage(userLogPage + 1);
        setUserLogPageSize(userLogPageSize + 1);
      }}
      hasMore={userLogs?.has_next}
      isLoading={loadingStates?.isUserLogsLoading}
    />
  );
}

function UserDemo() {
  return (
    <div className=" flex flex-col gap-6 ">
      <UserDemoTable />
    </div>
  );
}

export default UserDemo;
